<template>
  <div class="bg-f8f8f8 pt-20 relative">
    <div class="absolute bg-design2 mob-hidden main-auto">
      <img src="@/views/admin/layouts/image/Polygon 9.svg" alt="bg-polygon" />
    </div>

    <div class="lg:px-8 md:px-8 px-5 pt-8">
      <div class="md:flex">
        <div
          class="md:w-1/5 zindex-1 w-full h-100vh cust-overflow-y-primary-color-grey bg-white rounded-lg"
        >
          <div class="w-full">
            <div>
              <div
                class="cardbody-p rounded-t-lg bg-purple py-4 px-3 sticky z-10 top-0 w-full"
              >
                <div
                  class="flex items-center cursor-pointer"
                  v-for="(item, index) in plan"
                  :key="'item-' + index"
                  @click="handleClick(item)"
                  :class="{
                    '': item.route === currentRoute.currentRoute.name,
                  }"
                >
                  <div
                    class="rounded-full flex justify-center bg-white items-center"
                  >
                    <feather-icon
                      :icon="item.planicon"
                      class="cursor-pointer p-3 icon-size-left"
                      :class="{
                        ' text-primary':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    ></feather-icon>
                  </div>

                  <div class="ml-4">
                    <p
                      class="font-semibold text-base text-white"
                      :class="{
                        ' text-primary':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      {{ item.planname + userData.firstname }}
                    </p>
                    <!-- <base-button
                      filled
                      type="success"
                      class="flex py-0-5 px-2 mt-1"
                    >
                       @click="addBanner" 
                      <feather-icon
                        icon="UploadIcon"
                        class="mr-1 h-18w-18"
                      ></feather-icon
                      ><a class="buttontext">Upgrade</a>
                    </base-button> -->
                  </div>
                </div>
              </div>

              <div class="px-2">
                <b-card class="cardbody-pl border-0" no-body>
                  <div
                    class="flex items-center cursor-pointer hover:bg-gray-50 py-1 px-1 mt-3 rounded-lg"
                    v-for="(item, index) in menuOption"
                    :key="'item-' + index"
                    @click="handleClick(item)"
                    :class="{
                      'bg-f4f5f6 text-white rounded-lg':
                        item.route === currentRoute.currentRoute.name,
                    }"
                  >
                    <feather-icon
                      :icon="item.iconB"
                      class="cursor-pointer p-3 text-primary icon-size-left"
                      :class="{
                        ' text-primary':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    ></feather-icon>

                    <div class="ml-2">
                      <p
                        class="font-semibold text-base"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      >
                        {{ item.textB }}
                      </p>
                    </div>
                  </div>
                </b-card>

                <div class="rounded-lg mt-2" v-if="userData.role == 'vendor'">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisibleVendor = !isCollapseVisibleVendor
                      "
                    >
                      <!-- <feather-icon
                        icon="HeartIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon> -->
                      <img
                        src="../../../assets/images/Admin/community1.png"
                        alt="community"
                        class="pl-3 py-1"
                      />
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Shop</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleVendor"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                          <!-- abc -->
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleVendor"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in vendorcollapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text11 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>

                <!-- <div class="bg-purple py-2 px-4 flex fixed bottom-0 ">
                <feather-icon
                  icon="PhoneIcon"
                  class="cursor-pointer p-3 text-white icon-size-left"
                ></feather-icon>

                <div class="text-center mx-auto">
                  <p class="font-semibold text-base text-white">
                    Contact Us
                  </p>
                </div>
              </div> -->
              </div>
              <!-- <div class=" fixed bottom-0 w-full">
              <base-button
                block
                type="primary"
                class="rounded-none font-semibold w-full"
                >SUBMIT</base-button
              >
            </div> -->
            </div>
          </div>
        </div>
        <!-- <div class="absolute bg-design8">
          <img
            src="../../../assets/images/dots.svg"
            alt="bg-polygon"
            class="h-full w-full mt-30px"
          />
        </div> -->

        <div class="md:w-4/5 w-full md:pl-3">
          <router-view> </router-view>
        </div>

        <div class="absolute bg-design3">
          <img
            src="@/views/admin/layouts/image/Polygon 9.svg"
            alt="bg-polygon"
            class="h-150px"
          />
        </div>
        <!-- <div class="w-1/5 pl-4 h-83vh bg-white">
          <div class="w-full p-2 rounded-xl">
            <div class="">
              <div
                class="flex items-center cursor-pointer"
                v-for="(item, index) in plan"
                :key="'item-' + index"
                @click="handleClick(item)"
                :class="{
                  '': item.route === currentRoute.currentRoute.name
                }"
              >
                <div
                  class="rounded-full flex justify-center bg-primary items-center h-star"
                >
                  <feather-icon
                    :icon="item.planicon"
                    class="cursor-pointer p-3 text-white"
                    :class="{
                      ' text-primary':
                        item.route === currentRoute.currentRoute.name
                    }"
                  ></feather-icon>
                </div>

                <div class="ml-4">
                  <p
                    class="font-semibold text-base"
                    :class="{
                      ' text-primary':
                        item.route === currentRoute.currentRoute.name
                    }"
                  >
                    {{ item.planname }}
                  </p>
                  <base-button
                    filled
                    type="success"
                    class="flex py-0-5  px-2"
                    @click="addBanner"
                  >
                    <feather-icon
                      icon="UploadIcon"
                      class="mr-1 h-18w-18"
                    ></feather-icon
                    ><a class="buttontext">Upgrade</a>
                  </base-button>
                </div>
              </div>
            </div>
            <div class="mt-2">
              <div class="py-1 flex">
                <feather-icon
                  icon="UploadIcon"
                  class="mr-1 my-auto"
                ></feather-icon>
                <p class="ml-4">Upgrade</p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// import "../scss/Index.scss";
import { mapState } from "vuex";
export default {
  data() {
    return {
      plan: [
        {
          planname: "Hello, ",
          planicon: "StarIcon",
          route: "admin-subscriberplan",
        },
      ],
      menuOption: [
        {
          iconB: "MonitorIcon",
          textB: "Dashboard",
          route: "add-vendor",
        },
        // {
        //   iconB: "MonitorIcon",
        //   textB: "Order Management",
        //   route: "vendor-order-management",
        // },
      ],

      vendorcollapse: [
        {
          icon3: "ChevronRightIcon",
          text11: "Products",
          route: "product-vendor",
        },
        {
          icon3: "ChevronRightIcon",
          text11: "Order Management",
          route: "vendor-order-management",
        },
      ],

      isCollapseVisibleVendor: false,
    };
  },

  computed: {
    currentRoute() {
      return this.$router;
    },
    isEmployee() {
      return (
        this.user && this.user._id != null && this.user.role === "employee"
      );
    },
    ...mapState("auth", ["userData"]),
    ...mapState("cms", ["pageCategories"]),
  },

  methods: {
    handleClick({ route }) {
      this.$router.push({ name: route });
      this.pageCategories.forEach((element) => {
        if (element.route == route) {
          this.categoryId = element._id;
          this.$store.dispatch("cms/getfilterbycategory", {
            categoryPage: element._id,
          });
          this.$store.dispatch("cms/getTagsbyCategory", {
            categoryPage: element._id,
          });
          this.$store.commit("cms/SET_SELECTEDPAGECATEGORY", {
            id: element._id,
            name: element.name,
          });
          this.$store.dispatch("cms/getpagebycategory", {
            id: element._id,
          });
        }
      });
    },
    async pageCategory() {
      await this.$store.dispatch("cms/getPageCategories");
    },
    addRoutes() {
      if (this.userData.role == "vendor") {
        this.$router.push({ name: "add-vendor" });
      }
      if (this.userData.role != "student") {
        this.elearningCollapse.splice(3, 0, {
          text3: "Courses",
          icon3: "ChevronRightIcon",
          route: "admin-coursesdetails",
        });
      }
      if (this.userData.role == "admin" || this.userData.role == "intern") {
        if (this.userData.role != "intern") {
          this.menuOption.push({
            iconB: "UsersIcon",
            textB: "Manage Users",
            route: "user",
          });
        }
        this.elearningCollapse.splice(
          4,
          0,
          {
            icon3: "ChevronRightIcon",
            text3: "Course Categories",
            route: "admin-training",
          },
          {
            icon3: "ChevronRightIcon",
            text3: "Authors",
            route: "admin-trainersDashboard",
          }
        );
      }
      if (this.userData.role == "employee") {
        this.$router.push({ name: "admin-dashboard" });
      }
    },
    showCorporatebooking() {
      this.$router.push({ name: "admin-corporateBooking" });
    },
    showPushNotification() {
      this.$router.push({ name: "admin-push" });
    },
    showCompanydashboard() {
      this.$router.push({ name: "admin-dashboard" });
    },
    showaddbooking() {
      this.$router.push({ name: "admin-addbooking" });
    },
    isshowspecializedcategory() {
      this.$router.push({ name: "admin-specializedcaregiver" });
    },
  },
  mounted() {
    this.addRoutes();
  },
};
</script>

<style>
.main-auto {
  margin-left: -3rem;
  width: 250px;
  overflow: hidden;
}
.h-250px {
  height: 250px;
}
.mt-30px {
  margin-top: 30px;
}
.h-150px {
  height: 150px;
}
.zindex-1 {
  z-index: 1;
}
.h-100vh {
  height: 100vh;
}
</style>
